export default __webpack_public_path__ + "static/media/ful.aad2f09f.svg";